
export enum AnalyticsType {
    VISIT_BACK_TESTING = "VISIT_BACK_TESTING",
    VISIT_CHARTING = "VISIT_CHARTING",
    VISIT_CLEARING_DASHBOARD = "VISIT_CLEARING_DASHBOARD",
    VISIT_HOME_PAGE = "VISIT_HOME_PAGE",
    VISIT_ORDERS = "VISIT_ORDERS",
    VISIT_PERFORMANCE = "VISIT_PERFORMANCE",
    VISIT_PORTFOLIO = "VISIT_PORTFOLIO",
    VISIT_STRATEGY_BUILDER = "VISIT_STRATEGY_BUILDER"
}
